package org.vreo.devicehub.features.roi.presentation.components

import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.MoreVert
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ListItem
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.ListItemDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp

import org.jetbrains.compose.resources.stringResource
import org.vreo.devicehub.features.core.domain.device.roi.Roi
import devicehub.composeapp.generated.resources.Res
import devicehub.composeapp.generated.resources.roi_bay_id_label
import devicehub.composeapp.generated.resources.roi_editor_delete_button_label
import devicehub.composeapp.generated.resources.roi_editor_edit_button_label


/**
 * Roi list composable
 *
 * @param items list of ROIs to be displayed
 * @param selectedId ID of the selected ROI
 * @param onClick handler to handle object click functionality
 * @param onEdit handler to handle object edit functionality
 * @param onDelete handler to handle object delete functionality
 */
@Composable
fun RoiList(
    items: List<Roi>,
    selectedId: Int? = null,
    onClick: (Roi) -> Unit = {},
    onEdit: ((Roi) -> Unit)? = null,
    onDelete: ((Roi) -> Unit)? = null,
) {
    Column {
        items.forEach { item ->
            var expanded by remember { mutableStateOf(false) }

            ListItem(
                colors = if (item.id == selectedId) {
                    ListItemDefaults.colors(
                        containerColor = MaterialTheme.colorScheme.primaryContainer,
                        headlineColor = MaterialTheme.colorScheme.onPrimaryContainer,
                        trailingIconColor = MaterialTheme.colorScheme.onPrimaryContainer,
                    )
                } else {
                    ListItemDefaults.colors()
                },
                headlineContent = {
                    Row(
                        horizontalArrangement = Arrangement.spacedBy(8.dp),
                    ) {
                        Text(stringResource(Res.string.roi_bay_id_label))
                        Text(item.id.toString())
                    }
                },
                trailingContent = {
                    IconButton(
                        onClick = { expanded = !expanded },
                    ) {
                        Icon(Icons.Default.MoreVert, "")
                    }

                    DropdownMenu(
                        expanded = expanded,
                        onDismissRequest = { expanded = false }
                    ) {
                        if (onEdit != null) {
                            DropdownMenuItem(
                                text = { Text(stringResource(Res.string.roi_editor_edit_button_label)) },
                                onClick = {
                                    expanded = false
                                    onEdit(item)
                                }
                            )
                        }

                        if (onDelete != null) {
                            DropdownMenuItem(
                                text = { Text(stringResource(Res.string.roi_editor_delete_button_label)) },
                                onClick = {
                                    expanded = false
                                    onDelete(item)
                                }
                            )
                        }
                    }
                },
                modifier = Modifier
                    .fillMaxWidth()
                    .combinedClickable(
                        onClick = { onClick(item) }
                    )
            )
            HorizontalDivider()
        }
    }
}

@Preview
@Composable
fun RoiListItemPreview() {
    val items = listOf(
        Roi(id = 0, label = "Bay-1"),
        Roi(id = 1, label = "Bay-2"),
        Roi(id = 2, label = "Bay-3")
    )

    MaterialTheme {
        RoiList(
            items = items,
            selectedId = 0
        )
    }
}